module.exports = __webpack_public_path__ + "img/w_answer.3332ac4e.png";